// extracted by mini-css-extract-plugin
module.exports = {"removeModal":"index_removeModal__xQm0_"};